import { render, staticRenderFns } from "./FansList.vue?vue&type=template&id=07911816&scoped=true&"
import script from "./FansList.vue?vue&type=script&lang=js&"
export * from "./FansList.vue?vue&type=script&lang=js&"
import style0 from "./FansList.vue?vue&type=style&index=0&id=07911816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07911816",
  null
  
)

component.options.__file = "FansList.vue"
export default component.exports